/** Data saver for live TV: remembered on each device, because it depends on the connection that device is on. */
const KEY = 'zflix_live_saver';

export const liveSaverOn = () => {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch (_) {
    return false;
  }
};

export const setLiveSaver = (on) => {
  try {
    localStorage.setItem(KEY, on ? '1' : '0');
  } catch (_) {}
};
